<template>
  <div>
    <!-- Navigation Progress Bar -->
    <Transition name="fade">
      <div v-if="isNavigating" class="nav-progress-bar">
        <div class="nav-progress-bar__fill"></div>
      </div>
    </Transition>

    <RouterView />
    <NotificationContainer />
    <RateLimitModal />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { RouterView, useRouter } from 'vue-router';
import NotificationContainer from '@/components/baseNotifications/NotificationContainer.vue';
import RateLimitModal from '@/components/ui/RateLimitModal.vue';

//tst
declare global {
  interface Window { HSStaticMethods: any; }
}

const router = useRouter();
const isNavigating = ref(false);

router.beforeEach(() => {
  isNavigating.value = true;
});

router.afterEach(() => {
  // Small delay so the bar is visible even on instant navigations
  setTimeout(() => {
    isNavigating.value = false;
  }, 300);
});

onMounted(() => {
  setTimeout(() => {
    if (window.HSStaticMethods) {
      window.HSStaticMethods.autoInit();
    }
  }, 100);
});
</script>

<style scoped>
.nav-progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 9999;
  background: transparent;
  overflow: hidden;
}

.nav-progress-bar__fill {
  height: 100%;
  background: #6366f1;
  animation: progress 1s ease-in-out infinite;
  transform-origin: left;
}

@keyframes progress {
  0% {
    transform: translateX(-100%) scaleX(0.5);
  }

  50% {
    transform: translateX(0%) scaleX(0.8);
  }

  100% {
    transform: translateX(100%) scaleX(0.5);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>